import React, { useEffect, useState } from 'react';
import { getImageFromBackend } from 'modules/utils';
import styled from 'styled-components';

interface IBasicProps {
	width?: number | string;
	height?: number | string;
	color?: string;
}

interface IProps extends IBasicProps{
	logoPath?: string;
}

const SVGWrapper = styled.div<IBasicProps>`
	svg {
		width: ${(props) => props.width || "auto"};
		height: ${(props) => props.height || "auto"};

		path,
		g,
		polygon {
			fill: ${(props) => props.color || "#FFFFFF"};
		}
	}
`;

export const SVGLoader: React.FC<IProps> = ({logoPath, width, height, color}) => {
	const [svg, setSvg] = useState("");
	const SvgUrl = getImageFromBackend(logoPath);
	const isSVG = logoPath?.includes(".svg");

	useEffect(() => {
		if (logoPath && isSVG) {
			fetch(SvgUrl)
				.then((res) => res.text())
				.then(setSvg);
		}
	}, [logoPath, SvgUrl, isSVG]);

	if (!logoPath) {
		console.warn("Invalid logo for round");
		return null;
	}

	if (logoPath && !isSVG) {
		return <img src={SvgUrl} width={width} height={height} alt={logoPath} />;
	}

	return (
		<SVGWrapper
			width={width}
			height={height}
			color={color}
			className="svgInline"
			dangerouslySetInnerHTML={{__html: svg}}
		/>
	);
};

